import { handleActions } from "redux-actions";

import { setReceivers } from "./actions";

const initialState = {
    isLoadingReceivers: false,
    codes: [],
    receivers: {}
};

export const receiverReducer = handleActions(
    {
        [setReceivers]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);